import PurchaseItem from "./purchase-item";

export default class Purchase {
  id: number = 0;
  projectId: number = 0;
  projectName: string = "";
  staffName: string = "";
  title: string = "";
  mention: string = "";
  status: string = "created";
  statusName: string = "";
  estimateId: number = 0;
  estimateTotal: number = 0;
  estimateSubtotal: number = 0;
  estimateTax: number = 0;
  estimateTaxRate: number = 0;
  vendorId: number = 0;
  vendorName: string = "";
  loss: number = 0;
  lossTotal: number = 0;
  tax: number = 0;
  taxRate: number = 0;
  items: PurchaseItem[] = [];
  printsExcludeTax: boolean = false;
  issuedAt: string = "";
  profit: number = 0;
  profitRate: number = 0;
  dateOfIssue: string = "";
  purchaseNumber?: string = "";
  estimateNumber?: string = "";
}

export class PurchasePayment extends Purchase {
  amountReceived!: number;
  paymentDate: string = "";
  note: string = "";
  projectCreated: string = "";
  bankAccountId!: number;
  orderedDate!: string;
}
